import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoGd: CultureInfo = {
  name: 'gd',
  displayName: 'Scottish Gaelic',
  iso3LanguageCode: 'gla',
  iso2LanguageCode: 'gd',
  ietfLanguageTag: 'gd',
  parent: null
};
